module.exports = __webpack_public_path__ + "img/telegram.b0589b5.svg";